jQuery(function($)
{
    var
        api = orion.api.cart,
        $header = $('header'),
        $container = $('#basket-onsite');

    function updateCart()
    {
        api.read().done(function(data)
        {
            console.log('updateCart ausgefuehrt');
            $('.total', $container).html(data.response.cart.grandTotalString);
            $('#basket-onsite').data('cart-quantity', data.response.cart.productItemCount);
            $('#basket-onsite').trigger('basketUpdate');

            $header.trigger(orion.constants.EventCartUpdated);
        })
            .fail(function(xhr, status, error)
            {
                console.log(error);
            });
    }

    function handleProductCreated()
    {
        updateCart();
    }

    function handleProductUpdated()
    {
        updateCart();
    }

    function handleProductDeleted()
    {
        updateCart();
    }

    $('body')
        .on(orion.constants.EventCartProductCreated, handleProductCreated)
        .on(orion.constants.EventCartProductUpdated, handleProductUpdated)
        .on(orion.constants.EventCartProductDeleted, handleProductDeleted);
});
